import { render, staticRenderFns } from "./b_AutoJoin.vue?vue&type=template&id=0916b378&scoped=true&"
import script from "./b_AutoJoin.vue?vue&type=script&lang=js&"
export * from "./b_AutoJoin.vue?vue&type=script&lang=js&"
import style0 from "./b_AutoJoin.vue?vue&type=style&index=0&id=0916b378&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0916b378",
  null
  
)

export default component.exports